/**
 *
 * @module experience/billing-landing
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
export const BILLING_CONSTANTS = {
  SCHEDULED_TEXT: 'scheduled',
  PREPAID: 'prepaid',
  POSTPAID: 'postpaid',
  MAX_BAR_GRAPH_FOR_MOB: 4,
  AMOUNT: 0,
  AMOUNTPERCENTAGE: 100,
  PERCENTAGE: 90,
  BILLING_AMOUNT: 'billAmount',
  BILLING_DETAILS: 'billing',
  MAX_BAR_GRAPH: 7,
  TOTAL_AMOUNT: 'totalAmount',
  TRUE: 'true',
  BILLING_LANDING_MODULE: 'BillingLandingModule',
  CHARGE_PER_BILL_CYCLE: 'chargePerBillCycle',
  NAVIGATE_BILLING_DETAILS: 'billing-details',
  REDEEM_CARD: 'redeem-card',
  REFILL_REDEEM_CARD: 'refill-redeem-card',
  AUTO_PAY: 'auto-pay',
  OTP: 'one-time-payment',
  CANCELLED: 'CANCELLED',
  CLOSED: 'CLOSED',
  MAKEAPAYMENT: 'Make a payment',
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  CURRENCY_CODE: 'USD',
  CURRENCY_DISPLAY: 'symbol-narrow',
  SUBSTATUS_LOST: 'Lost/Stolen',
  SUBSTATUS_UNPAID: 'Unpaid',
  STATUS_SUSPENDED: 'SUSPENDED',
  DATE_FORMAT: 'MM/dd/yyyy',
  TOTAL_ALLOWED_LINES: 5,
  MINUS_SIX: -6,
};
